import i18n from "@/libs/i18n";
import { useApiKeysStore } from "@/store/useApiKeysStore";
import { RequestQueryBuilder } from "@rewiko/crud-request";
import { computed, ref, watch } from "@vue/composition-api";

export default function useApiKeys() {
    const refTable = ref(null);
    const tableColumns = [
        {
            key: "key",
            label: `${i18n.t("settings.developers.api-keys.api-key")} (x-api-key)`,
            sortable: true,
        },
        {
            key: "expiresAt",
            label: i18n.t("settings.developers.api-keys.expires-at"),
            sortable: true,
            thStyle: "width: 15%",
        },
        { key: "actions", label: i18n.t("settings.users.actions"), thStyle: "width: 15%" },
    ];
    const perPage = ref(10);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref("");
    const sortBy = ref("id");
    const isSortDirDesc = ref(true);

    const dataMeta = computed(() => {
        const localItemsCount = refTable.value ? refTable.value.localItems.length : 0;

        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: total.value,
        };
    });

    const read = () => {
        const { fetchApiKeys } = useApiKeysStore();

        fetchApiKeys(
            RequestQueryBuilder.create({
                fields: ["id", "key", "expiresAt"],
                limit: perPage.value,
                page: currentPage.value,
                sort: {
                    field: sortBy.value,
                    order: isSortDirDesc.value === true ? "DESC" : "ASC",
                },
            })
        );
    };

    const refetchData = () => {
        refTable.value.refresh();
    };

    watch([currentPage, perPage, searchQuery], () => {
        if (searchQuery.value.length > 0 && searchQuery.value.length < 2) {
            return;
        }

        refetchData();
    });

    return {
        read,
        refetchData,
        tableColumns,
        perPage,
        currentPage,
        total,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refTable,
    };
}
